import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "15",
  viewBox: "0 0 14 15",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.2727 5.73533C12.5929 5.90561 12.8607 6.1598 13.0475 6.47066C13.2343 6.78152 13.3329 7.13734 13.3329 7.5C13.3329 7.86266 13.2343 8.21848 13.0475 8.52934C12.8607 8.84021 12.5929 9.09439 12.2727 9.26467L3.73135 13.9093C2.35602 14.6573 0.666687 13.684 0.666687 12.1453V2.85533C0.666687 1.31533 2.35602 0.342668 3.73135 1.09L12.2727 5.73533Z" }, null, -1)
  ])))
}
export default { render: render }